// @flow

import {
  FEDRAMP_SUPPORTED_ESTIMATE_ACCORDION_KEYS,
  FEDRAMP_SUPPORTED_CLUSTER_USAGE_TAB_KEYS,
} from './constants';

export const filterAccordionPanelsByFedRAMPMode = (accordionPanels, isFedRAMPEstimate) => {
  if (!isFedRAMPEstimate) {
    return accordionPanels;
  }

  return accordionPanels.filter((panel) =>
    FEDRAMP_SUPPORTED_ESTIMATE_ACCORDION_KEYS.includes(panel.key)
  );
};

export const filterClusterUsageTabsByFedRAMPMode = (tabPanes, isFedRAMPEstimate) => {
  if (!isFedRAMPEstimate) {
    return tabPanes;
  }

  return tabPanes.filter((tabPane) =>
    FEDRAMP_SUPPORTED_CLUSTER_USAGE_TAB_KEYS.includes(tabPane.menuItem.key)
  );
};
